<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'companyImages.title' | translate }}</h2>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="row spacing-30">
      @if (companyImages.length > 0) {
        <div class="col-lg-12 col-12 d-flex flex-wrap gap-3">
          @for (image of companyImages; track image.image_id) {
            <div class="image-input image-input-outline position-relative" data-kt-image-input="true" style="background-image: url(/assets/media/svg/avatars/blank.svg)">
              <div class="image-input-wrapper w-125px h-125px" [style.background-image]="'url(' + image.image_url + ')'"
                   [class.opacity-50]="deletingImageId === image.image_id"></div>
              @if (deletingImageId === image.image_id) {
                <div class="position-absolute top-50 start-50 translate-middle">
                  <span class="spinner-border spinner-border-sm text-danger" role="status"></span>
                </div>
              }
              <span
                class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow"
                (click)="deleteImage(image)"
                [class.disabled]="deletingImageId !== null"
                data-kt-image-input-action="remove"
                data-bs-toggle="tooltip"
                data-bs-dismiss="click"
                [title]="'common.delete' | translate"
              >
                <i class="ki-outline ki-cross fs-3"></i>
              </span>
            </div>
          }
        </div>
      } @else {
        <p class="text-muted">{{ 'companyImages.noImages' | translate }}</p>
      }
    </div>
    <div class="row">
      <div class="col-lg-12 col-12">
        <app-fileorini
          [accept]="'.png,.jpg,.jpeg'"
          [maxFiles]="50"
          [maxSizeMB]="20"
          (filesChanged)="onFilesChanged($event)"
        ></app-fileorini>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <app-button
      [label]="'common.close' | translate"
      [variant]="'outline'"
      (clicked)="modal.dismiss()"
    />
    <app-button
      [label]="'common.save' | translate"
      [variant]="'primary'"
      [disabled]="files.length === 0"
      (clicked)="uploadImages()"
    />
  </div>
</div>
